export default __webpack_public_path__ + "static/media/borde.d8be80b3.svg";